import {
  api as generatedApi,
  GetRoomsForUserDocument,
  type GetRoomsForUserQuery,
} from './operations.generated';
import { createQueryFnWithHeaders, type WithHeaders } from '../graphql.utils';

const api = generatedApi.injectEndpoints({
  endpoints: (build) => ({
    GetRoomsForUser: build.query<GetRoomsForUserQuery, WithHeaders | void>({
      queryFn: createQueryFnWithHeaders<GetRoomsForUserQuery>(
        GetRoomsForUserDocument,
      ),
    }),
  }),
  overrideExisting: true,
});

export const useGetRoomsForUserQuery: typeof api.useGetRoomsForUserQuery =
  api.useGetRoomsForUserQuery;
